import React, { useState, useEffect } from "react";
import { Autocomplete } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

export const HomeSearcher = ({ isCompact = false }) => {
  const [placeSearch, setPlaceSearch] = useState("");
  const [autocomplete, setAutocomplete] = useState(null);
  const [focused, setFocused] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setPlaceSearch(e.target.value);
  };

  const onLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        navigate(`/buscador/buscando/${lat}/${lng}`);
      }
    }
  };

  return (
    <main className="flex justify-center">
      <div
        className={
          isCompact
            ? `w-full max-w-[1200px]`
            : `w-[65dvw] min-w-[250px] max-w-[1200px] pb-10 sm:w-[90dvw]`
        }
      >
        <Autocomplete
          onLoad={onLoad}
          onPlaceChanged={onPlaceChanged}
          options={{
            componentRestrictions: { country: "UY" },
          }}
        >
          <div className="flex items-center relative">
            <input
            type="text"
            value={placeSearch}
            onChange={handleInputChange}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            placeholder={
              isCompact ? "Buscar ubicación..." : "¿Donde se perdió tu amigo?"
            }
            className={
  (isCompact
    ? "w-full h-8 landscape:h-10 px-[1rem] font-main placeholder:text-gray-500 placeholder:font-bold landscape:text-sm bg-gray-50 border border-gray-300 shadow-lg"
    : "w-full h-[4rem] landscape:h-[4rem] px-[1rem] font-main font-semibold placeholder:text-gray-500 placeholder:font-bold text-medium small:text-sm landscape:text-medium bg-gray-50 border border-gray-300 shadow-lg"
  ) +
  " transition-all duration-300 " +
  (focused && placeSearch ? "rounded-t-lg" : "rounded-lg")
}
          />
            <FaSearch
              className={`
              absolute right-4 text-secondary pointer-events-none
              ${isCompact ? "text-sm" : "text-lg"}
            `}
            />
          </div>
        </Autocomplete>
      </div>
    </main>
  );
};

export default HomeSearcher;
